<template>
  <DescriptionsItem
    :span="24"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :label="label"
    class="json-params-detail-item"
  >
    <el-collapse
      v-model="activeNames"
      @change="handleChange"
      accordion
      :class="[isFirstLevel ? 'is-first' : 'is-second']"
    >
      <el-collapse-item :name="item.identifier" v-for="(item, index) in jsonArr" :key="index">
        <span class="collapse-item-title" slot="title">
          <template v-if="activeNames === item.identifier"
            >{{ $t('Product.params') }}{{ index + 1 }}</template
          >
          <template v-else>
            <DescriptionsItem
              :span="24"
              labelWidth="auto"
              :labelAlign="labelAlign"
              :label="`${$t('Product.params')}${index + 1}`"
            >
              {{ item.name }}
            </DescriptionsItem>
          </template>
        </span>
        <div class="collapse-item-content">
          <DescriptionsItem
            :span="24"
            :labelWidth="labelWidth"
            :labelAlign="labelAlign"
            :label="$t('Product.paramName')"
          >
            {{ item.name }}
          </DescriptionsItem>
          <DescriptionsItem
            :span="24"
            :labelWidth="labelWidth"
            :labelAlign="labelAlign"
            :label="$t('Product.identifier')"
          >
            {{ item.identifier }}
          </DescriptionsItem>
          <DescriptionsItem
            :span="24"
            :labelWidth="labelWidth"
            :labelAlign="labelAlign"
            :label="$t('Product.dataType')"
          >
            {{ item.dataType }}
          </DescriptionsItem>
          <DataTypeDetailItem
            :info="item"
            :labelWidth="labelWidth"
            :labelAlign="labelAlign"
            :isFirstLevel="isFirstLevel"
          ></DataTypeDetailItem>
        </div>
      </el-collapse-item>
    </el-collapse>
  </DescriptionsItem>
</template>

<script>
import DescriptionsItem from '@/components/Descriptions/DescriptionsItem'

import { format, formatTime } from '@/utils/utils'
export default {
  props: {
    label: {
      type: String
    },
    labelWidth: {
      type: String
    },
    labelAlign: {
      type: String
    },
    jsonArr: {
      type: Array
    },
    isFirstLevel: {
      type: Boolean,
      default: true
    },
    isSecondLevel: {
      type: Boolean,
      default: true
    }
  },
  components: {
    DescriptionsItem,
    DataTypeDetailItem: () => import('./DataTypeDetailItem')
  },
  data() {
    return {
      activeNames: ''
    }
  },
  filters: {
    format,
    formatTime
  },
  methods: {
    handleChange() {}
  }
}
</script>

<style lang="scss" scoped>
.json-params-detail-item {
  /deep/.el-collapse {
    border: 0;
    .el-collapse-item {
      background: #f4f8fe;
      margin-bottom: 8px;
      padding: 16px;
      border-radius: 16px;
    }
    .hl-descriptions-item {
      margin-bottom: 12px;
      line-height: 1;
    }
    .el-collapse-item__header {
      background-color: transparent;
      border-bottom: 0;
      height: auto;
      line-height: 1;
      padding: 4px 0;
      .hl-descriptions-item {
        margin-bottom: 0;
        padding: 0 !important;
      }
    }
    .el-collapse-item__wrap {
      margin-top: 16px;
      background-color: transparent;
      border-bottom: 0;
    }
    &.is-second {
      .el-collapse-item {
        background: #fbfdff;
        border: 1.5px solid rgba(233, 237, 243, 1);
        box-sizing: border-box;
      }
      .el-collapse-item__header {
        padding: 2px 0;
      }
    }
    .el-collapse-item__header.is-active {
      & > .collapse-item-title {
        position: relative;
        z-index: 1;
        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          height: 5px;
          width: 100%;
          background: $text-emphasis-color;
          border-radius: 12px;
          z-index: -1;
        }
      }
    }
  }
}
</style>
